var reloadCartTimeout;

$(document).ready(function(){
  $('[data-quantity-input]').on('change', function(){
    if(reloadCartTimeout){
      clearTimeout(reloadCartTimeout);
    }

    jQuery('#addtocartbutton').prop('disabled', true);
    jQuery('.additional-checkout-buttons').hide();

    reloadCartTimeout = setTimeout(function(){
      window.location.reload()
    }, 1000);
  });
});
